import {
  CarrotAdBaseEntity,
  CarrotAdBaseEntityParams,
} from "@shared/services/event_tracking/entities";
import { CarrotTypes } from "@shared/services/event_tracking/carrot_tracking";
interface CarrotSponsoredProductAdEntityParams extends CarrotAdBaseEntityParams {
  placement_position?: number;
  product_line_id?: number;
}
export class CarrotSponsoredProductAdEntity extends CarrotAdBaseEntity {
  display_position: number;
  product_line_id: number;

  constructor(params: CarrotSponsoredProductAdEntityParams) {
    super(params);
    this.type = CarrotTypes.SponsoredProduct;
    this.entity_version = 2;
    this.display_position = params.placement_position;
    this.product_line_id = params.product_line_id;
  }
}
